import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import Button from "components/CustomButtons/Button.js";
import Spinner from "components/Spinner";
import { Alert, AlertTitle } from "@material-ui/lab";
import { isEmptyObject } from "helpers/utils";
import ComboBox from "components/ComboBox";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(2),
      width: 200,
    },
  },
  newUserButton: {
    display: "flex",
    justifyContent: "center",
  },
}));

export default function VillageCreator({
  loading,
  onCreate,
  status,
  userError,
  districtsKv,
  subcountysKv,
  parishsKv,
}) {
  const classes = useStyles();
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const handleChange = (event, name) => {
    if (!isEmptyObject(errors)) {
      setErrors({});
    }
    let oldData = { ...data };
    oldData[name] = event.target.value;
    setData(oldData);
  };
  const handleDistrictSelection = (e) => {
    if (!isEmptyObject(errors)) {
      setErrors({});
    }
    let oldData = { ...data };
    oldData["districtId"] = e.target.value;
    setData(oldData);
  };
  const handleSubcountySelection = (e) => {
    if (!isEmptyObject(errors)) {
      setErrors({});
    }
    let oldData = { ...data };
    oldData["subcountyId"] = e.target.value;
    setData(oldData);
  };
  const handleParishSelection = (e) => {
    if (!isEmptyObject(errors)) {
      setErrors({});
    }
    let oldData = { ...data };
    oldData["parishId"] = e.target.value;
    setData(oldData);
  };
  const handleClick = () => {
    let errorList = {};
    if (!data.districtId) errorList.districtId = "field cannot be empty";
    if (!data.subcountyId) errorList.subcountyId = "field cannot be empty";
    if (!data.parishId) errorList.parishId = "field cannot be empty";
    if (!data.name) errorList.name = "field cannot be empty";
    if (isEmptyObject(errorList)) {
      onCreate(data);
    } else setErrors(errorList);
  };
  const checkError = (field) => {
    return errors[field] !== undefined;
  };
  return (
    <form className={classes.root} noValidate autoComplete="off">
      <div>
        <ComboBox
          error={errors["districtId"]}
          value={data["districtId"]}
          label={"District"}
          onSelect={handleDistrictSelection}
          kvOptions={districtsKv}
        />
        <ComboBox
          error={errors["subcountyId"]}
          value={data["subcountyId"]}
          label={"Subcounty"}
          onSelect={handleSubcountySelection}
          kvOptions={subcountysKv}
        />
        <ComboBox
          error={errors["parishId"]}
          value={data["parishId"]}
          label={"Parish"}
          onSelect={handleParishSelection}
          kvOptions={parishsKv}
        />
        <TextField
          error={checkError("name")}
          label="Name"
          id="name"
          value={data.name}
          onChange={(e) => handleChange(e, "name")}
          variant="outlined"
          helperText={errors.name}
          size="small"
        />
      </div>
      {loading && <Spinner />}
      {!loading && status === "FAILED" && (
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          {userError || "Village creation failed!"}
        </Alert>
      )}
      {!loading && status === "SUCCESS" && (
        <Alert severity="success">
          <AlertTitle>Success</AlertTitle>
          Village creation successful!
        </Alert>
      )}
      <div className={classes.newUserButton}>
        <Button color="primary" round disabled={loading} onClick={handleClick}>
          Create New Village
        </Button>
      </div>
    </form>
  );
}
VillageCreator.propTypes = {
  loading: PropTypes.bool.isRequired,
  onCreate: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  userError: PropTypes.string,
  districtsKv: PropTypes.array.isRequired,
  subcountysKv: PropTypes.array.isRequired,
  parishsKv: PropTypes.array.isRequired,
};
